module.exports = __webpack_public_path__ + "img/leave-luggage.df48d9fb.svg";